import React from 'react'
import styled from '@emotion/styled'
import { BsFillStarFill } from 'react-icons/bs'

const PremiumListContainer = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-right: 8px;
  align-items: center;
  width: 100%;
  height: 550px;
  margin-top: 20px;
`

const Header = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: end;
  align-items: end;
  width: 100%;
  padding: 0 20px;
`

const Tittle = styled("div")`
  display: flex;
  flex-direction: row;
  //justify-content: flex-start;
  //align-content: center;
  align-items: center;
`

const DomainListContainer = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  border-radius: 7px;
  background: #c7bfff33;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  &::-webkit-scrollbar {
    width: 10px;
    border: 1px none #22253D;
    border-radius: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: #B8860B;
    border-radius: 5px;
  }
`

const DomainListHeader = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  width: 100%;
  padding-right: 30px;
  padding-left: 30px;
`


const PremiumList = ({premiumDomainsList}) => {

  if(!premiumDomainsList) return null
  return (
    <PremiumListContainer>
      <Header>
        <Tittle>
          {/*<BsFillStarFill style={{color: '#F0C17D', width:"35px", height:"35px"}}/>*/}
          <h1 style={{color: '#FFFFFF', marginBottom: "0px"}}>TOP LEVEL Domains</h1>
        </Tittle>
        <h4 style={{color: 'white', marginBottom: "0px"}}>Total: {premiumDomainsList.length}/1000 </h4>
      </Header>
      <DomainListContainer>
        <DomainListHeader>
          <h5 style={{color: '#ACACAC', marginBottom: "3px"}}>PFP</h5>
          <h5 style={{color: '#ACACAC', marginBottom: "3px"}}>Domains Name</h5>
          <h5 style={{color: '#ACACAC', marginBottom: "3px"}}>Supreme Domains Upgrade Time</h5>
        </DomainListHeader>
        <div style={{borderBottom: "thin solid white", width: "96%", marginBottom: "1px"}}/>
        {premiumDomainsList.map((domain, index) => (
          <div key={index} style={{display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%", padding: "0 20px", borderBottom: "1px solid #3C3F5C", marginTop:"5px"}}>
            <a href={`https://${process.env.REACT_APP_METADATA_DOMAIN}/endurance/${process.env.REACT_APP_BASE_REGISTRAR}/${domain.label}/image`} target="_blank" rel="noopener noreferrer">
              <img
                src={`https://${process.env.REACT_APP_METADATA_DOMAIN}/endurance/${process.env.REACT_APP_BASE_REGISTRAR}/${domain.label}/image`}
                alt="domain"
                style={{width: "50px", height: "50px", border: "1px solid #3C3F5C"}}
              />
            </a>
            <h4 style={{color: 'white', paddingLeft:"0px"}}>{domain.name}.ace</h4>
            <a
              href={`${process.env.REACT_APP_EXPLORER_URL}/tx/${domain.transactionID}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{color: 'white', paddingLeft:"0px"}}
            >
              <h5>
                {(new Date(domain.timestamp * 1000)).toString().split("(")[0]}
              </h5>
            </a>
          </div>
        ))}
      </DomainListContainer>

    </PremiumListContainer>
  )
}

export default PremiumList
